import type { DateParts } from './resolveEventDateCase'
import { resolveEventDateCase } from './resolveEventDateCase'
import type { EventDateInput } from './resolveEventDateCase'

export type { EventDateInput }

const PRONTO_TEXT = 'PRÓXIMAMENTE'

function formatParts(parts: DateParts): string {
  return `${parts.day}/${parts.month}/${parts.year}`
}

/**
 * Produce el texto de fecha normalizado de un evento (FR-001 a FR-013). Ya no
 * decide por sí mismo qué caso aplica — delega esa decisión de negocio a
 * `resolveEventDateCase` (compartida con `formatEventDateTabla`, el
 * formateador de `ProductosTabla`) y solo traduce cada caso a su propio
 * texto en `dd/mm/yyyy`, sin cambios respecto al comportamiento anterior —
 * ver contracts/formatEventDate.md y research.md §4 (Clarifications, sesión
 * 2026-07-30 (2)), y specs/037-productos-tabla/research.md §1.
 */
export function formatEventDate(input: EventDateInput): string {
  const dateCase = resolveEventDateCase(input)

  switch (dateCase.kind) {
    case 'literal':
      return dateCase.text
    case 'pronto':
      return PRONTO_TEXT
    case 'single':
      return formatParts(dateCase.date)
    case 'open-start':
      return `Desde el ${formatParts(dateCase.start)}`
    case 'open-end':
      return `Hasta el ${formatParts(dateCase.end)}`
    case 'closed-range':
      return `Del ${formatParts(dateCase.start)} al ${formatParts(dateCase.end)}`
  }
}
